export const userAgentIsBot = () => {
    return /storage365bot|prerendercloud|googlebot|yahoo|bingbot|duckduckbot|baiduspider|twitterbot|facebot|facebookexternalhit|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest|slackbot|vkShare|W3C_Validator|redditbot|Applebot|WhatsApp|flipboard|tumblr|bitlybot/i
        .test(navigator.userAgent);
};
